export default __webpack_public_path__ + "static/media/valley4.81bc8d05.png";